import { Modal, Box, Typography, IconButton, Button } from '@mui/material';
import { Close } from '@mui/icons-material';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 600 },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};

export default function FaqModal({ open, onClose, faq, onAsk }) {
    if (!faq) return null;

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8 }}>
                    <Close />
                </IconButton>
                <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
                    FAQ Details
                </Typography>
                <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', maxHeight: '60vh', overflowY: 'auto' }}>
                    {faq.content}
                </Typography>
                <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid #eee' }}>
                    <Typography variant="caption" display="block">
                        <strong>Client:</strong> {faq.client_name} ({faq.client_code})
                    </Typography>
                    <Typography variant="caption" display="block">
                        <strong>Created At:</strong> {new Date(faq.created_at).toLocaleString()}
                    </Typography>
                </Box>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button variant="contained" onClick={onAsk}>Ask Copilot</Button>
                </Box>
            </Box>
        </Modal>
    );
}
